import React from 'react'
import './index.less'
import classNames from 'classnames'

type Type = 'default' | 'primary' | 'textPrimary' | 'text' | 'link' | 'error' | 'normal'

export interface ButtonProps{
  type?: Type,
  disabled?: boolean,
  active?:boolean,
  children: React.ReactNode,
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
}

export default ({ type = 'default', disabled, active, children, className, style, onClick, ...otherProps }:ButtonProps) => {
  return <a
    className={classNames('mn-btn', type, { disabled, active }, className)}
    style={style}
    onClick={(e) => {
      if (disabled) { return }
      onClick && onClick(e)
    }}
    {...otherProps}
  >
    {children}
  </a>
}
